import * as types from '../../actions/actiontypes';
import {isApiResponseOk} from '../../util/utils';

const initialState = {};

export function relateDeficienciesToControlReducer(state = initialState, action) {
	switch (action.type) {
		case types.LIST_RELATE_DEFICIENCIES_TO_CONTROL: {
			if (!isApiResponseOk(action)) {
				return state;
			}
			return action.response || state;
		}
		default:
			return state;
	}
}
